import { computed, ref } from "vue";

const STORAGE_KEY = "site_language";
const SUPPORTED_LANGUAGES = ["ja", "zh", "en"];
const initialLanguage = (() => {
  if (typeof window === "undefined") {
    return "zh";
  }

  const saved = window.localStorage.getItem(STORAGE_KEY);
  return SUPPORTED_LANGUAGES.includes(saved) ? saved : "zh";
})();

const currentLanguage = ref(initialLanguage);

export function setSiteLanguage(nextLanguage) {
  if (!SUPPORTED_LANGUAGES.includes(nextLanguage)) {
    return;
  }

  currentLanguage.value = nextLanguage;
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, nextLanguage);
  }
}

export function useSiteLanguage() {
  const lang = computed({
    get: () => currentLanguage.value,
    set: (value) => setSiteLanguage(value),
  });

  return {
    lang,
    languages: SUPPORTED_LANGUAGES,
    setLang: setSiteLanguage,
  };
}
